
import { Vue, Options } from 'vue-class-component';

/**
 * Pagina default que NotFound.
 */
@Options({
  components: {},
  name: 'PadronInscripciones',
})
export default class NotFoundPage extends Vue {
  goBack() {
    this.$router.back();
  }
}
